import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table, CommonErrors } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_HS_APP,
    SG_APP_HS_CODE_LIST_R,
    SG_HS_APRV_HIST_LIST,
} from "@/tz/go/egaz/osci/lpco/hscd/itm/service/OsciHscdItmService";

export const OSCI0204003S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const pgeTitle = "Registering Control HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { hsAppId } = useParams();

    const [hsAppDtlList, setHsAppDtlList] = useState(comnUtils.getGridData([]));
    const [hsAppAprvHistList, setHsAppAprvHistList] = useState(comnUtils.getGridData([]));

    const [prcssStatCd, setPrcssStatCd] = useState("");

    const refEditable = useRef(false);

    const tab = useTab({
        defaultSchema: {
            id: "tab",
            schema: [{ label: t("L_HS_CD") }, { label: t("T_APRV_HIST") }],
        },
    });

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "hsCd" },
            { area: "comnCd", comnCd: "OSC0133" },
            { area: "comnCd", comnCd: "OSC0134" },
            { area: "comnCd", comnCd: "OSC0132" },
            { area: "comnCd", comnCd: "OSC0131" },
            { area: "comnCd", comnCd: "OSC0119" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        hsAppForm: useForm({
            defaultSchema: SF_SCHEMA_HS_APP,
            defaultValues: { orgCd: auth.get("orgCd"), orgNm: auth.get("orgNm") },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        appHsCodeList: useGrid({
            defaultSchema: SG_APP_HS_CODE_LIST_R,
            page: 0,
            size: 10,
        }),
        hsAppAprvHistList: useGrid({
            defaultSchema: SG_HS_APRV_HIST_LIST,
            page: 0,
            size: 10,
        }),
    };
    const render = {
        appHsCodeList: {
            head: {},
            cell: {},
            edit: {},
            row: (row: any, context: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 row 보임
                // return 값이 false 이면 row 숨김
                // context 의 속성을 변경하여 row 의 바탕색 변경 가능
                if (row.prcsRoleTpCd === "SU" || row.prcsRoleTpCd === "AP") {
                    //context.backgroundColor = "blue"; // 3가지 색상 옵션 red , yellow , blue
                }
                return true;
            },
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                return !(row.deletableYn === "N");
            },
        },
        hsAppAprvHistList: {},
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getOgaHsCdList: useFetch({
            api: (orgCd) => {
                return APIS.getOgaHsCdList(orgCd);
            },
            onSuccess: (data) => {
                console.log("getOgaHsCdList onSuccess ", data.list?.content);
                // form.lpcoInfoRgsr.setValues(data.appInfo.content?.info);
                setHsAppDtlList(comnUtils.getGridData(data.list?.content || []));
            },
            onError: () => {},
            showToast: false,
        }),
        getHsAppInfo: useFetch({
            api: (hsAppId) => {
                return APIS.getHsAppInfo(hsAppId);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                if (!data.appInfo.content.info || !data.appInfo.content.info?.hsAppId) {
                    // no data
                    modal.openModal({
                        content: "msg.osc.00050",
                        onCancel: () => {
                            navigate(URLS.osci0204002q);
                        },
                    });
                } else {
                    form.hsAppForm.setValues(data.appInfo.content.info);

                    const orgChpnId = form.hsAppForm.getValue("orgChpnId");
                    const prcssStatCd = form.hsAppForm.getValue("prcssStatCd");
                    refEditable.current =
                        (orgChpnId == auth.get("usrId") || orgChpnId == auth.get("asisSysmUsrId")) &&
                        (prcssStatCd == "DR" || prcssStatCd == "RE");

                    setPrcssStatCd(prcssStatCd);
                    setHsAppDtlList(comnUtils.getGridData(data.appInfo?.content?.list || []));
                }
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.osc.00043" });
            },
            showToast: false,
        }),
        deleteHsAppInfo: useFetch({
            api: (hsAppId) => {
                return APIS.deleteHsAppInfo(hsAppId);
            },
            onSuccess: (data) => {
                // no data
                modal.openModal({
                    content: "msg.osc.00071",
                    onCancel: () => {
                        navigate(URLS.osci0204002q);
                    },
                });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
        getHsAppAprvHistList: useFetch({
            api: (hsAppId) => {
                return APIS.getHsAppAprvHistList(hsAppId);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                setHsAppAprvHistList(comnUtils.getGridData(data.result?.content || []));
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.osc.00043" });
            },
            showToast: false,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Delete Item list deletion event !== 품목 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridAppHsCodeList: () => {
            const seltList: any[] = grid.appHsCodeList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.appHsCodeList.deleteRow("checkbox");

            // modal.openModal({
            //     content: "msg.osc.00095",
            //     onConfirm: () => {
            //         grid.appHsCodeList.deleteRow("checkbox");
            //     },
            // });
        },
        deleteHsAppInfo: (hsAppId: any) => {
            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    fetch.deleteHsAppInfo.fetch(hsAppId);
                },
            });
        },
        setInit: async () => {
            // HS App Information
            await fetch.getHsAppInfo.fetch(hsAppId);

            await fetch.getHsAppAprvHistList.fetch(hsAppId);
        },
    };

    // useEffect
    useEffect(() => {
        handler.setInit();
        form.hsAppForm.setEditable(false);
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("L_APP_INFO")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnTelno} />
                            <Group.Control {...form.hsAppForm.schema.orgChpnEml} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.hsAppNo} />
                            <Group.Control {...form.hsAppForm.schema.prcssStatCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    navigate(URLS.osci0204002q);
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {refEditable.current && (
                                <>
                                    <Button
                                        role="edit"
                                        onClick={() => {
                                            navigate(URLS.osci0204004s + "/" + hsAppId);
                                        }}
                                    />
                                    <Button
                                        role="delete"
                                        onClick={() => {
                                            handler.deleteHsAppInfo(hsAppId);
                                        }}
                                    />
                                </>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab {...tab.tab}>
                        <Tab.Panel>
                            <Group>
                                <Group.Body>
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("L_HS_CD_LST")} titleSize={1}></Group.Title>
                                        </Layout.Left>
                                        <Layout.Right>
                                            <Button
                                                role="excelDown"
                                                onClick={() => {
                                                    comnUtils.exportExcel({
                                                        url: `${BASE.api}/${hsAppId}/excel-down`,
                                                        fileName: "HS code information list",
                                                    });
                                                }}
                                            />
                                        </Layout.Right>
                                    </Layout>

                                    <Group.Section>
                                        <Grid
                                            {...grid.appHsCodeList.grid}
                                            data={hsAppDtlList}
                                            render={render.appHsCodeList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Tab.Panel>
                        <Tab.Panel>
                            <Group>
                                <Group.Body>
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_APRV_HIST")} titleSize={1}></Group.Title>
                                        </Layout.Left>
                                        <Layout.Right></Layout.Right>
                                    </Layout>

                                    <Group.Section>
                                        <Grid
                                            {...grid.hsAppAprvHistList.grid}
                                            data={hsAppAprvHistList}
                                            render={render.hsAppAprvHistList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Tab.Panel>
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
